import { Stack, Typography } from "@mui/material";
import {
  actionLabel,
  attachmentLabel,
  fixedRecipient,
} from "./automationSetupApprovalCopy";

export default function AutomationApprovalSummary({ card }) {
  const recipient = fixedRecipient(card);
  const attachment = attachmentLabel(card);
  return (
    <Stack
      spacing={0.5}
      sx={{
        p: 1.25,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1.5,
      }}
    >
      <Typography variant="subtitle2">{actionLabel(card)}</Typography>
      <Typography variant="body2" color="text.secondary">
        Sends at most one time whenever this automation matches an event.
      </Typography>
      {recipient ? (
        <Typography variant="body2">To: {recipient}</Typography>
      ) : null}
      {attachment ? (
        <Typography variant="body2">{attachment}</Typography>
      ) : null}
    </Stack>
  );
}
